export function formatApiResponse(
  val: number | string | undefined,
  decimal = 0,
  asPercent = false,
): string {
  if (val === null || val === undefined || val === "") {
    return "-";
  }

  const num = typeof val === "number" ? val : parseFloat(val);
  if (isNaN(num)) {
    return String(val);
  }
  const value = asPercent ? num * 100 : num; // パーセント変換はここで制御
  return value.toFixed(decimal);
}
